import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'svc-app-barcode',
  templateUrl: './barcode-scanner.component.html',
  styleUrls: ['./barcode-scanner.component.scss'],
})
export class BarcodeScannerComponent implements OnInit {
  constructor() {}

  ngOnInit() {}
  // barcode = '';
  // error: string = '';
  // dank: string = '';
  // configQuagga: any = {
  //   inputStream: {
  //     name: 'Live',
  //     type: 'LiveStream',
  //     target: document.querySelector('#inputBarcode'),
  //     constraints: {
  //       facingMode: 'environment'
  //     },
  //     // area: {
  //     //   // defines rectangle of the detection/localization area
  //     //   top: '20%', // top offset
  //     //   right: '20%', // right offset
  //     //   left: '20%', // left offset
  //     //   bottom: '20%' // bottom offset
  //     // },
  //     // halfSample: true,
  //     // patchSize: 'medium',

  //     singleChannel: false // true: only the red color-channel is read
  //   },
  //   locator: {
  //     patchSize: 'x-large',
  //     halfSample: false,
  //     debug: {
  //       drawBoundingBox: true,
  //       showFrequency: true,
  //       drawScanline: true,
  //       showPattern: true
  //     }
  //   },
  //   locate: true,
  //   decoder: {
  //     readers: ['code_39_vin_reader', 'code_39_reader', 'code_128_reader']
  //   }
  // };
  // constructor(private ref: ChangeDetectorRef) {}

  // ngOnInit() {
  //   console.log('Barcode: initialization');
  //   this.startScanner();
  // }

  // ngOnDestroy() {
  //   Quagga.stop();
  // }

  // testChangeValues() {
  //   this.barcode = 'Code-barres bidon : 0123456789';
  // }

  // startScanner() {
  //   this.barcode = '';
  //   this.ref.detectChanges();

  //   Quagga.onProcessed((result: any) => this.onProcessed(result));

  //   Quagga.onDetected((result: any) => this.logCode(result));

  //   Quagga.init(this.configQuagga, (err: any) => {
  //     if (err) {
  //       this.error = err;
  //       return console.log(err);
  //     }
  //     Quagga.start();
  //     console.log('Barcode: initialization finished. Ready to start');
  //   });
  // }

  // private onProcessed(result: any) {
  //   //this.dank = result;
  //   const drawingCtx = Quagga.canvas.ctx.overlay;
  //   const drawingCanvas = Quagga.canvas.dom.overlay;

  //   if (result) {
  //     if (result.boxes) {
  //       drawingCtx.clearRect(
  //         0,
  //         0,
  //         parseInt(drawingCanvas.getAttribute('width'), 10),
  //         parseInt(drawingCanvas.getAttribute('height'), 10)
  //       );
  //       result.boxes
  //         .filter(function(box: any) {
  //           return box !== result.box;
  //         })
  //         .forEach(function(box: any) {
  //           Quagga.ImageDebug.drawPath(box, { x: 0, y: 1 }, drawingCtx, { color: 'green', lineWidth: 2 });
  //         });
  //     }

  //     if (result.box) {
  //       Quagga.ImageDebug.drawPath(result.box, { x: 0, y: 1 }, drawingCtx, { color: '#00F', lineWidth: 2 });
  //     }

  //     if (result.codeResult && result.codeResult.code) {
  //       Quagga.ImageDebug.drawPath(result.line, { x: 'x', y: 'y' }, drawingCtx, { color: 'red', lineWidth: 3 });
  //     }
  //   }
  // }

  // private logCode(result: any) {
  //   this.dank = result;
  //   const code = result.codeResult.code;
  //   if (this.barcode !== code) {
  //     this.barcode = 'Code-barres EAN : ' + code;
  //     this.ref.detectChanges();
  //     console.log(this.barcode);
  //     Quagga.stop();
  //   }
  // }
}
